
import { mapState } from 'vuex'
export default {
    async fetch() {
        await this.$store.dispatch('jsonloader/fetchJson', `products.json`)
    },
    computed: {
        ...mapState({ contentTypes: (state) => state.data.contentTypes || [] }),

        contentType() {
            const contentType = (this.contentTypes || []).find((el) => el.slug === this.$route.params.taxonomyid)
            if (contentType) return contentType
            return (this.contentTypes || []).reduce((acc, el) => [...acc, ...el.children], []).find((el) => el.slug === this.$route.params.taxonomyid) || {}
        },
    },
}
